












































































































































































import { Component, Vue } from "vue-property-decorator";
import {
  AbsenceFilter,
  AbsenceTypeEnum,
  AbsenceViewModel,
  PublicHolidayFilter,
  PublicHolidayViewModel,
  RightEnum,
  VacationStatsViewModel
} from "@/services/api/nswag/stapiclient_generated";
import { stAbsenceApi, stPublicHolidayApi } from "@/services/st-api";
import AbsenceEdit from "@/views/Absence/AbsenceEdit.vue";
import StTabs from "@/components/tabs/StTabs.vue";
import { TabModel } from "@/components/tabs/tab-model";
import { DateTime } from "luxon";
import StBadge from "@/components/basic/StBadge.vue";
import { notifySuccess } from "@/utlitities/notifications";
import AbsenceLegend from "@/views/Absence/AbsenceLegend.vue";
import UserSelect from "@/views/TimeEntries/UserSelect.vue";
import { TimeEntryStore } from "@/store/time-entry-store";
import { UserStore } from "@/store/user-module";
import AbsenceTypeIcon from "@/views/Absence/components/AbsenceTypeIcon.vue";
import { getAbsenceColor, getPublicHolidayColor } from "@/views/Absence/helper/get-absence-color";

@Component({
    components: {
      AbsenceTypeIcon,
      UserSelect,
      AbsenceLegend,
      StBadge,
      StTabs,
      AbsenceEdit,
    },
  })
  export default class OwnAbsences extends Vue {
    absences: AbsenceViewModel[] = [];
    publicHolidays: PublicHolidayViewModel[] = [];
    vacationStats: VacationStatsViewModel = VacationStatsViewModel.fromJS({});
    year: number = DateTime.local().year;
    activeTabName = 'calendar';
    loading = true;
    delayLoading = false;

    get tabs(): TabModel[] {
      return [
        {
          TabName: 'calendar',
          Disabled: false,
        },
        {
          TabName: 'list',
          Disabled: false,
        },
      ];
    }

    get canEditAbsencesForEmployees(): RightEnum {
      return RightEnum.CanEditAbsencesForEmployees;
    }

    get selectedUserId() {
      return TimeEntryStore.selectedUserId;
    }

    set selectedUserId(data: number) {
      TimeEntryStore.SetSelectedUserId(data);
    }

    async updateCalendar(calendarEvent: any) {
      if (!calendarEvent.weekday) {
        this.year = calendarEvent.year;
        await this.loadData();
      }
    }

    async beforeRouteUpdate(to: any, from: any, next: any) {
      next();
      if (to.name == 'Ownabsences') {
        try {
          await this.loadData();
        } finally {
        }
      }
    }

    loadDataDelayLoading() {
      this.loadData();
    }

    dayclick(e: any) {
      let id = 0;
      if (e.attributes[0] && e.attributes[0].customData.absenceId) {
        id = e.attributes[0].customData.absenceId;
      }
      if (this.selectedUserId != UserStore.currentUser.id)
      {
        this.$router.push({ name: 'TeamAbsencesFromCalenderEdit', params: { id: id.toString() }, query: { userId: this.selectedUserId.toString(), day: e.id } });
      } else {
        this.$router.push({ name: 'OwnabsencesEdit', params: { id: id.toString() }, query: { day: e.id } });
      }
    }

    editAbsence(id: number) {
      if (this.selectedUserId != UserStore.currentUser.id)
      {
        this.$router.push({ name: 'TeamAbsencesFromCalenderEdit', params: { id: id.toString() }, query: { userId: this.selectedUserId.toString() } });
      } else {
        this.$router.push({ name: 'OwnabsencesEdit', params: { id: id.toString() }});
      }
    }

    addAbsence() {
      if (this.selectedUserId != UserStore.currentUser.id)
      {
        this.$router.push({ name: 'TeamAbsencesFromCalenderEdit', params: { id: '0' }, query: { userId: this.selectedUserId.toString(), day: DateTime.local().toFormat('yyyy-MM-dd') } });
      } else {
        this.$router.push({ name: 'OwnabsencesEdit', params: { id: '0' }, query: { day: DateTime.local().plus({ days: 1 }).toFormat('yyyy-MM-dd') } });
      }
    }

    async deleteAbsence(id: number) {
      await stAbsenceApi.delete(id, true);
      await this.loadData();
      notifySuccess('Erfolgreich gelöscht');
    }

    async changeYear(plusminus: number) {
      try {
        this.loading = true;
        this.year += plusminus;
        await this.loadData();
      } finally {
        this.loading = false;
      }
    }

    get fromDate(): Date {
      return DateTime.local(this.year, 1, 1, 0, 0, 0, 0).toJSDate();
    }

    getHighlightColorForAbsence(absence: AbsenceViewModel | null | undefined) {
      if (absence === null || absence === undefined) {
        return '';
      }

      const absenceColor = getAbsenceColor(absence)

      return {color: absenceColor.VCalendarHighlightColor, fillMode: absenceColor.VCalendarHighlightFillMode};
    }

    getDot(absence: AbsenceViewModel | null | undefined){
      if (absence === null || absence === undefined) {
        return '';
      }

      const absenceColor = getAbsenceColor(absence)

      return absenceColor.VCalendarDotColor ? {color: absenceColor.VCalendarDotColor, class: 'h-5 w-5'} : null;
    }

    get attributes(): any[] {
      let attr = [];

      const phColor = getPublicHolidayColor();
      let publicHolidays = this.publicHolidays.map((ph) => {
        return {
          dates: ph.publicHolidayDate,
          highlight: { color: phColor.VCalendarHighlightColor, fillMode: phColor.VCalendarHighlightFillMode },
          popover: { visibility: 'hover' },
          customData: { isPublicHoliday: true, publicHolidayId: ph.id, description: ph.description },
        };
      });

      // abgelehnte Anträge werden ausgeblendet
      let absences = this.absences
        .filter((_) => {
          return !(_.isApprovalDecided && !_.isApproved);
        })
        .map((absence) => {
          return {
            dates: { start: absence.dateFrom, end: absence.dateTo },
            highlight: this.getHighlightColorForAbsence(absence),
            dot: this.getDot(absence),
            popover: { visibility: 'hover' },
            customData: { isAbsence: true, absenceId: absence.id, absence: absence, absenceType: absence.absenceType?.description },
          };
        });

      attr.push(...absences);
      attr.push(...publicHolidays);
      return attr;
    }

    mounted() {
      try {
        if (!this.selectedUserId) {
          this.selectedUserId = UserStore.currentUser.id ?? 0;
        }
        this.loading = true;
        this.loadDataRaw();
      } finally {
        this.loading = false;
      }
    }

    async loadDataRaw() {
      let results = await Promise.all([
        stAbsenceApi.getList(AbsenceFilter.fromJS({ year: this.year, appUserId: this.selectedUserId })),
        stPublicHolidayApi.getListForCurrentUser(PublicHolidayFilter.fromJS({ year: this.year, appUserId: this.selectedUserId })),
        stAbsenceApi.getVacationStatsForUser(this.year, this.selectedUserId),
      ]);

      this.absences = results[0];
      this.publicHolidays = results[1];
      this.vacationStats = results[2];
    }

    async loadData() {
      try {
        this.delayLoading = true;
        await this.loadDataRaw();
      } finally {
        this.delayLoading = false;
      }
    }
  }
